import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthService } from '@core/auth';

@Component({
    selector: 'app-not-found',
    templateUrl: './not-found.component.html',
    styleUrls: ['./not-found.component.scss'],
    imports: [RouterModule],
    standalone: true,
})
export class NotFoundComponent {
    public constructor(public auth: AuthService) {}
}
